<template>
  <v-dialog v-model="dialogImage" max-width="600" persistent>
    <v-card>
      <v-card-title class="primary white--text py-2">
        <span class="text-subtitle-1">Xem ảnh</span>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePopup">
          <i class="fas fa-times"></i>
        </v-btn>
      </v-card-title>
      <!-- Content -->
      <v-card-text class="pa-0">
        <v-layout justify-center align-center style="min-height: 300px; background-color: #f5f5f5;">
          <v-flex xs12 text-center pa-4>
            <img :src="imageUrl" alt="Hình ảnh chi tiết" class="responsive-image">
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closePopup">Đóng</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "image-viewer",
  props: ["dialogImage", "imageUrl"],
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
  },
};
</script>

<style scoped>
.responsive-image {
  max-width: 100%;
  max-height: 70vh; /* Giới hạn chiều cao tối đa của ảnh bằng 70% chiều cao viewport */
  object-fit: contain; /* Đảm bảo toàn bộ ảnh được hiển thị, có thể có khoảng trống */
  border-radius: 4px;
}
</style>